/**
 * Centralised, code-editable configuration for the assessment app.
 * Changing values here requires a redeploy.
 *
 * NOTE: The authoritative values for QUESTIONS_PER_QUIZ and MAX_ATTEMPTS
 * live in netlify/functions/_lib/quiz.js — they are enforced server-side.
 * The values here are only used for client-side display.
 */
export const APP_CONFIG = {
  QUESTIONS_PER_QUIZ: 15,
  MAX_ATTEMPTS: 4,
  APP_TITLE: 'IBMA Assessment',
};
